<app-item-details-tabs (tabPanelChange)="onTabPanelChange($event)">
    <ng-container Generale [ngTemplateOutlet]="generale"></ng-container>
    <ng-container Canali [ngTemplateOutlet]="canali"></ng-container>
    <ng-container Dettagli [ngTemplateOutlet]="dettagli"></ng-container>
    <ng-container Varianti [ngTemplateOutlet]="varianti"></ng-container>
    <ng-container Magazzino [ngTemplateOutlet]="magazzino"></ng-container>
    <ng-container Comande [ngTemplateOutlet]="comande"></ng-container>
</app-item-details-tabs>

<ng-template #generale>
    <app-item-general
        [item]="item"
    ></app-item-general>
</ng-template>

<ng-template #canali>
    <app-item-channels
        [item]="item"
    ></app-item-channels>
</ng-template>

<ng-template #inventario>
    <app-item-inventory
        [item]="item"
    ></app-item-inventory>
</ng-template>

<ng-template #dettagli>
    <app-item-details-section
        [item]="item"
    ></app-item-details-section>
</ng-template>

<ng-template #varianti>
    <app-item-variations-section
        [item]="item"
    ></app-item-variations-section>
</ng-template>

<ng-template #magazzino>
    <app-item-stock
        [item]="item"
        [itemStock]="itemStock"
    ></app-item-stock>
</ng-template>

<ng-template #comande>
    <app-item-printers
        [item]="item"
    ></app-item-printers>
</ng-template>

<ng-template #default>
    <button mat-flat-button color="primary" class="tw-absolute tw-top-[50%] tw-left-[50%] -tw-translate-x-[50%] -tw-translate-y-[50%] tw-text-2xl tw-p-7">Richiedi attivazione Modulo</button>
</ng-template>